var _path, _path2, _path3, _path4, _path5;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogoLetmeupMark(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 15,
    viewBox: "0 0 23 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.27214 10.6896H0.745395C0.333766 10.6896 0 10.3559 0 9.94422V0.745395C0 0.333766 0.333766 0 0.745395 0H9.27214C9.68376 0 10.0175 0.333766 10.0175 0.745395V9.94422C10.0175 10.3559 9.68376 10.6896 9.27214 10.6896Z",
    fill: "#00BEC1"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.0175 9.78992C10.0175 12.5561 7.77497 14.7987 5.00877 14.7987C2.24256 14.7987 0 12.5561 0 9.78992",
    fill: "#00BEC1"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M19.4323 7.05781H11.4287C11.0262 7.05781 10.7002 6.73178 10.7002 6.32926V0.728548C10.7002 0.326025 11.0262 0 11.4287 0H19.4323C19.8348 0 20.1608 0.326025 20.1608 0.728548V6.32926C20.1608 6.73178 19.8348 7.05781 19.4323 7.05781Z",
    fill: "#00BEC1"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M19.3453 7.05781C21.2943 7.05781 22.8742 5.47786 22.8742 3.5289C22.8742 1.57994 21.2943 0 19.3453 0C17.3963 0 15.8164 1.57994 15.8164 3.5289C15.8164 5.47786 17.3963 7.05781 19.3453 7.05781Z",
    fill: "#00BEC1"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M14.2291 14.7987C16.1781 14.7987 17.758 13.2187 17.758 11.2697C17.758 9.32079 16.1781 7.74084 14.2291 7.74084C12.2801 7.74084 10.7002 9.32079 10.7002 11.2697C10.7002 13.2187 12.2801 14.7987 14.2291 14.7987Z",
    fill: "#00BEC1"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoLetmeupMark);
export default __webpack_public_path__ + "static/media/Logo_letmeupMark.98c2d3b7f469ee1697cb1b504a5501a2.svg";
export { ForwardRef as ReactComponent };